module.exports = __webpack_public_path__ + "img/blaz-login.ecf90c09.png";